import React from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import PropTypes from 'prop-types';

import { useAgentModal } from '../../context/AgentModalContext';
import logomarkInk from '../../assets/brand/logos/logomark-ink.svg';

import './Breadcrumb.css';

const Breadcrumb = ({ customLabels = {}, onOpenTasks, onToggleSidebar, sidebarOpen = false }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const pathnames = location.pathname.split('/').filter((x) => x);
  const { openAgentModal } = useAgentModal();

  // eslint-disable-next-line no-console
  console.log('[Breadcrumb] Current path:', location.pathname);
  // eslint-disable-next-line no-console
  console.log('[Breadcrumb] Pathnames:', pathnames);

  // Default labels for common routes
  const defaultLabels = {
    dashboard: 'Dashboard',
    analytics: 'Analytics',
    classroom: 'Classroom',
    courses: 'Courses',
    'create-course': 'Create Course',
    profile: 'Profile',
    reflection: 'Reflection',
    library: 'Library',
    video: 'Video',
    ...customLabels,
  };

  const getLabel = (segment) => {
    // Check if it's a dynamic ID (UUID pattern or number)
    if (/^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(segment)) {
      return 'Details';
    }
    if (/^\d+$/.test(segment)) {
      return 'Details';
    }
    // Check for date pattern (YYYY-MM-DD)
    if (/^\d{4}-\d{2}-\d{2}$/.test(segment)) {
      return segment; // Show the date as-is
    }
    return defaultLabels[segment] || segment.charAt(0).toUpperCase() + segment.slice(1);
  };

  return (
    <>
      <nav className="breadcrumb-nav" aria-label="Breadcrumb">
        {onToggleSidebar && (
          <button
            type="button"
            onClick={onToggleSidebar}
            className="breadcrumb-sidebar-trigger"
            aria-label={sidebarOpen ? 'Close sidebar' : 'Open sidebar'}
            title={sidebarOpen ? 'Close sidebar' : 'Open sidebar'}
          >
            <i className={`fa-solid ${sidebarOpen ? 'fa-xmark' : 'fa-bars'}`} />
          </button>
        )}
        <ol className="breadcrumb-list">
          <li className="breadcrumb-item">
            {pathnames.length === 0 || pathnames[0] === 'dashboard' ? (
              <span className="breadcrumb-current">
                <img
                  src={logomarkInk}
                  alt=""
                  className="breadcrumb-brand-mark"
                  aria-hidden="true"
                />
                <span className="breadcrumb-label">Dashboard</span>
              </span>
            ) : (
              <Link to="/dashboard" className="breadcrumb-link">
                <img
                  src={logomarkInk}
                  alt=""
                  className="breadcrumb-brand-mark"
                  aria-hidden="true"
                />
                <span className="breadcrumb-label">Home</span>
              </Link>
            )}
          </li>
          {pathnames
            .filter((segment) => segment !== 'dashboard')
            .map((segment) => {
              const actualIndex = pathnames.indexOf(segment);
              const path = `/${pathnames.slice(0, actualIndex + 1).join('/')}`;
              const isLast = actualIndex === pathnames.length - 1;
              const label = getLabel(segment);

              return (
                <li key={path} className="breadcrumb-item">
                  <i className="fa-solid fa-chevron-right breadcrumb-separator" />
                  {isLast ? (
                    <span className="breadcrumb-current" aria-current="page">
                      {label}
                    </span>
                  ) : (
                    <Link to={path} className="breadcrumb-link">
                      {label}
                    </Link>
                  )}
                </li>
              );
            })}
        </ol>
        <div className="breadcrumb-actions">
          <button
            type="button"
            onClick={() => navigate('/create-course')}
            className="breadcrumb-action-button create-course-button"
            aria-label="Create Course"
            title="Create Course"
          >
            <i className="fa-solid fa-circle-plus" />
          </button>
          <button
            type="button"
            onClick={() =>
              openAgentModal({
                agentId: 'orchestrator',
                origin: 'breadcrumb',
                contextPayload: {
                  currentPath: location.pathname,
                  pathnames,
                },
              })
            }
            className="breadcrumb-action-button orchestrator-button"
            aria-label="Open Orchestrator Agent"
            title="Orchestrator Agent"
          >
            🧠
          </button>
          {onOpenTasks && (
            <button
              type="button"
              onClick={onOpenTasks}
              className="breadcrumb-action-button tasks-button"
              aria-label="Open Tasks Sidebar"
              title="Open Tasks"
            >
              <i className="fa-solid fa-list-check" />
            </button>
          )}
        </div>
      </nav>
    </>
  );
};

Breadcrumb.propTypes = {
  customLabels: PropTypes.object,
  onOpenTasks: PropTypes.func,
  onToggleSidebar: PropTypes.func,
  sidebarOpen: PropTypes.bool,
};

export default Breadcrumb;
